import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { INDUSTRY_OPTIONS } from "@/lib/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = { name: "", company: "", email: "", phone: "", industry: "", requirement: "", quantity: "", message: "" };

export const EnquiryForm = () => {
    const [form, setForm] = useState(EMPTY);
    const [loading, setLoading] = useState(false);

    const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        if (!form.industry) {
            toast.error("Please select your industry.");
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${API}/enquiries`, form);
            toast.success("Enquiry sent. Our team will reach out to you shortly.");
            setForm(EMPTY);
        } catch (err) {
            toast.error("Could not send your enquiry. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={submit} data-testid="enquiry-form" className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
                <label htmlFor="enquiry-name" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Name *</label>
                <input id="enquiry-name" data-testid="enquiry-name" required className="sf-input" placeholder="Your full name" value={form.name} onChange={set("name")} />
            </div>
            <div>
                <label htmlFor="enquiry-company" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Company Name *</label>
                <input id="enquiry-company" data-testid="enquiry-company" required className="sf-input" placeholder="Your company" value={form.company} onChange={set("company")} />
            </div>
            <div>
                <label htmlFor="enquiry-email" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Email *</label>
                <input id="enquiry-email" data-testid="enquiry-email" required type="email" className="sf-input" placeholder="name@company.com" value={form.email} onChange={set("email")} />
            </div>
            <div>
                <label htmlFor="enquiry-phone" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Phone Number *</label>
                <input id="enquiry-phone" data-testid="enquiry-phone" required className="sf-input" placeholder="+91 ..." value={form.phone} onChange={set("phone")} />
            </div>
            <div>
                <label htmlFor="enquiry-industry" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Industry *</label>
                <select id="enquiry-industry" data-testid="enquiry-industry" required className="sf-input appearance-none" value={form.industry} onChange={set("industry")}>
                    <option value="" disabled>Select your industry</option>
                    {INDUSTRY_OPTIONS.map((opt) => (
                        <option key={opt} value={opt} className="bg-sf-surface">{opt}</option>
                    ))}
                </select>
            </div>
            <div>
                <label htmlFor="enquiry-requirement" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Product / Manufacturing Requirement *</label>
                <input id="enquiry-requirement" data-testid="enquiry-requirement" required className="sf-input" placeholder="e.g. Shock absorber tubes" value={form.requirement} onChange={set("requirement")} />
            </div>
            <div className="md:col-span-2">
                <label htmlFor="enquiry-quantity" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Estimated Quantity / Production Requirement</label>
                <input id="enquiry-quantity" data-testid="enquiry-quantity" className="sf-input" placeholder="e.g. 50,000 pcs / month" value={form.quantity} onChange={set("quantity")} />
            </div>
            <div className="md:col-span-2">
                <label htmlFor="enquiry-message" className="block font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 mb-2">Message</label>
                <textarea id="enquiry-message" data-testid="enquiry-message" rows={5} className="sf-input resize-none" placeholder="Tell us about your requirement, drawings, timelines..." value={form.message} onChange={set("message")} />
            </div>
            <div className="md:col-span-2">
                <button type="submit" data-testid="enquiry-submit" disabled={loading} className="sf-btn-primary disabled:opacity-60 disabled:cursor-not-allowed">
                    {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowUpRight size={16} />}
                    {loading ? "Sending..." : "Send Business Enquiry"}
                </button>
            </div>
        </form>
    );
};
